import React, { useEffect, useRef, useState } from 'react';
import { useSpearPartsApi } from '../../../../store/api/hooks/spearPartsApiHook';
import { PAGE_SIZE } from '../../../../_common/constant';
import { showDate } from '../../../../_common/functions';
import Pagination from '../../../../components/pagination';
import Search from '../../../../components/search';
import { AgGridReact } from 'ag-grid-react';
import Button from '../../../../components/elements/button';
import Drawer from '../../../../components/Drawer';
import CreateCycleCount from '../../CycleCount/_components/createCyclecount';

interface genProps {
	partDetails: any;
}
const StockCycleCountHistory: React.FC<genProps> = ({ partDetails }) => {
	const spearPartsAPI = useSpearPartsApi();
	const [gridApi, setGridApi] = useState<any>(null);
	const [gridColumnApi, setGridColumnApi] = useState<any>(null);
	const [totalRecords, setTotalRecords] = useState<number>(0);
	const [currentPage, setCurrentPage] = useState<number>(1);
	const [searchParam, setSearchParam] = useState<string>('');

	const [rowData, setRowData] = useState<any>(null)

	const addNewCycleCountDrawerRef: any = useRef();
	const addNewCycleCountRef: any = useRef();

	const onGridReady = (params: any) => {
		setGridApi(params.api);
		setGridColumnApi(params.columnApi);
	};
	const onRowClicked = (event: any) => {
		if (!event.event.target.closest('input[type="checkbox"]')) {
			event.node.setSelected(false); // Unselect row if it's clicked, not by checkbox
		}
	};
	const getSpearPartsList = () => {
		spearPartsAPI.stockCycleCountHistory({
			PartID: partDetails.partsID,
			pageSize: PAGE_SIZE,
			pageNumber: currentPage,
			searchParam: searchParam,
		}, (data: any) => {
			setTotalRecords(data.totalRecord);
			setRowData(data.cycleCountByPartList ? data.cycleCountByPartList : []);
		}, (error: any) => {
			setRowData([]);
		});
	};

	useEffect(() => {
		getSpearPartsList();
	}, [currentPage, searchParam]);

	const columnDefs = [
		{ headerName: 'Count Ref No', field: 'inventoryCycleCountCode', headerClass: 'bg-[#f0f0f0]', width: 180 },
		{
			headerName: 'Count Date', field: 'countingDate', headerClass: 'bg-[#f0f0f0]', width: 130,
			cellRenderer: (data: any) => data.value ? showDate(data.value) : '--'
		},
		{ headerName: 'Facility', field: 'facilityName', headerClass: 'bg-[#f0f0f0]', minWidth: 170, flex:1 },
		//{ headerName: 'Sub Facility', field: 'subFacilityName', headerClass: 'bg-[#f0f0f0]', minWidth: 170, flex:1 },
		{
			headerName: 'Expected Qty', field: 'systemQuantity', headerClass: 'bg-[#f0f0f0]', width: 130,
			cellRenderer: (data: any) => {
				const systemQuantity = data.data?.systemQuantity || '--';
				const unitName = data.data?.unitName || '';
				return `${systemQuantity} ${unitName}`;
			}
		},
		{
			headerName: 'Counted Qty', field: 'countedQuantity', headerClass: 'bg-[#f0f0f0]', width: 170,
			cellRenderer: (data: any) => {
				const countedQuantity = data.data?.countedQuantity || '--';
				const unitName = data.data?.unitName || '';
				return `${countedQuantity} ${unitName}`;
			}
		},
		{ headerName: 'Counted By', field: 'countedByUserName', headerClass: 'bg-[#f0f0f0]', width: 170 },
		{ headerName: 'Notes', field: 'cycleCountNotes', headerClass: 'bg-[#f0f0f0]', minWidth: 170, flex:1 },
	];

	return (

		<div>
			<div className='flex items-center justify-between pl-5 pr-3 border-b border-gray-200 h-[3.75rem]'>
				<div className='flex items-center gap-2'>
					<h1 className='text-[0.9rem] leading-[1]'>Stock Cycle Count History</h1>
					<Pagination
						perPage={PAGE_SIZE}
						totalRecords={totalRecords}
						onPageChange={setCurrentPage}
						currentPage={currentPage}
					/>
				</div>
				<div className='flex items-center gap-2'>
					<Search onSearch={setSearchParam} />
					<Button theme='light' disabled >Export</Button>

					<Drawer _ref={addNewCycleCountDrawerRef} onClose={() => {
                        addNewCycleCountRef?.current?.reset()
                    }} outsideClose={false}>
                        <Drawer.Button>
							{/* <Button>New Cycle Count</Button> */}
                        </Drawer.Button>
						<Drawer.Content title={'Create New Cycle Count'} className='!w-[39.563rem]'>
							<CreateCycleCount _ref={addNewCycleCountRef} partDetails={partDetails} onCreate={() => {
								addNewCycleCountDrawerRef?.current?.close();
							}} onCancel={() => {
								addNewCycleCountDrawerRef?.current?.close();
							}} />
						</Drawer.Content>
					</Drawer>
				</div>
			</div>
			<div>
				<div className='bg-[#FAFAFA]'>
					<div className="ag-theme-alpine h-1/2">
						<AgGridReact
							columnDefs={columnDefs} // Pass columnDefs
							rowData={rowData || []} // Pass rowData
							pagination={false}
							rowSelection="multiple"
							onGridReady={onGridReady}
							domLayout="autoHeight"
							onRowClicked={onRowClicked}
							noRowsOverlayComponent={() => (
                            <div className="flex items-center justify-center h-full">
                                <div className="text-center text-gray-500">
                                    <div className="text-lg font-medium">No Data Found</div>
                                </div>
                            </div>
                        )}
						/>
					</div>
				</div>
			</div>
		</div>
	);
};

export default StockCycleCountHistory;